import React from "react";
import { Control, Controller } from "react-hook-form";
import { useController } from "react-hook-form";
import {useTranslation} from 'react-i18next';
import { STATUS_FIELD } from "@/Constant";
import { CaseSetupFormType } from "./type";
import { CASE_DESCRIPTION_ID, CASE_DESCRIPTION_ID_F, CASE_ID, CASE_ID_F, CASE_NAME, CASE_SHORT_ID } from "../Constants";
import InputBox from "@/components/Form/InputBox/InputBox";

type ControlInputBoxType = {
    required?: boolean;
    isTextArea?: boolean;
    control: Control<CaseSetupFormType>;
    name: typeof CASE_ID | typeof CASE_ID_F | typeof CASE_DESCRIPTION_ID | typeof CASE_DESCRIPTION_ID_F | typeof CASE_SHORT_ID | typeof STATUS_FIELD;
    showLabel: boolean;
    label: string;
}

export default function ControlInputBox ({name, control, required=false, isTextArea=false, showLabel, label}: ControlInputBoxType) {
    const {
        field,
      } = useController({
        name,
        control,
        rules: { required: required  },
      });
    const {t} = useTranslation();

    return (
        <> 
            {
                showLabel && <div className="formFieldLabel">
                    <label  htmlFor="input" aria-label={label}>{t(label)}{ required ? <span className="requiredSymbol">*</span> : ''}</label>
                </div>
            }
           <Controller
                name={field.name}
                control={control}
                rules={{ required }}
                render={({ field: { onChange, value, ...args } }) => {
                          return (
                          <>
                            <InputBox   id={CASE_NAME} required={true} value={value || ""} onChange={onChange} isTextArea={isTextArea} {...args}/>
                          </>
                          );
                    }}
            />
        </>
        
    );
}
